import { useCallback, useRef, useState } from "react";

/**
 * Prevents double-submit on Save / Sent to Office / review actions.
 * The ref lock is synchronous so two clicks in the same tick cannot both start.
 */
export function useSubmitLock() {
  const lockRef = useRef(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);

  const runLocked = useCallback(async (action, fn) => {
    if (lockRef.current) return;
    lockRef.current = true;
    setPendingAction(action || "submit");
    setIsSubmitting(true);
    try {
      return await fn();
    } finally {
      lockRef.current = false;
      setIsSubmitting(false);
      setPendingAction(null);
    }
  }, []);

  return { isSubmitting, pendingAction, runLocked };
}

export default useSubmitLock;
